import { render, staticRenderFns } from "./MyVip.vue?vue&type=template&id=43aa3e80&scoped=true&"
import script from "./MyVip.vue?vue&type=script&lang=js&"
export * from "./MyVip.vue?vue&type=script&lang=js&"
import style0 from "./MyVip.vue?vue&type=style&index=0&id=43aa3e80&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43aa3e80",
  null
  
)

export default component.exports